// removed by extract-text-webpack-plugin
module.exports = {"profile":"Profile__profile__3LJZv","separator":"Profile__separator__3S5L8","username":"Profile__username__1envE","avatar":"Profile__avatar__1Y_O1","logout":"Profile__logout__263IC","icon":"Profile__icon__3cAp-"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Header/Profile/Profile.scss
// module id = 1549
// module chunks = 0